import { Stack, Typography, useTheme } from "@mui/material";
import { SimpleComparisonTable } from "./Simple/SimpleComparisonTable";
import { MultivalueComparisonTable } from "./Multivalue/MultivalueComparisonTable";
import { Fragment } from "react/jsx-runtime";
import { useMyActionPlanContext } from "../../../context/useMyActionPlan";
import { useTranslation } from "react-i18next";

export const ImpactComparisonTables = () => {
    const theme = useTheme();
    const { impactDataSummary } = useMyActionPlanContext();

    if (impactDataSummary === null) {
        return null;
    }

    const { multiImpactTable, simpleImpactTable, summary } = impactDataSummary;

    if (summary.summary.length === 0) {
        return <EmptyImpactSummary />;
    }

    return (
        <Stack gap={theme.spacing(2)}>
            {multiImpactTable && <MultivalueComparisonTable multiImpactTable={multiImpactTable.tableData} />}
            {simpleImpactTable && (
                <Fragment>
                    {simpleImpactTable.tableData.map((tableData) => {
                        return (
                            <SimpleComparisonTable
                                key={`${tableData.property.id}-${tableData.position}`}
                                impactByAction={tableData}
                            />
                        );
                    })}
                </Fragment>
            )}
        </Stack>
    );
};

const EmptyImpactSummary = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack sx={{ paddingInline: theme.spacing(2) }}>
            <Typography variant="body">
                {t(
                    "action_plan.estimated_impact.no_estimation",
                    "Cette section sera disponible lorsque vous aurez renseigné les informations ci-dessus.",
                )}
            </Typography>
        </Stack>
    );
};
